import { AppBar, Box, Toolbar } from '@mui/material';
import { ReactComponent as WhiteLogo } from '../svg/logo_white.svg';
import Button from '@mui/material/Button';

interface HeaderProps {
  setIsOpen: (v: boolean) => void;
  isMobile: boolean;
}

export default function Header({ setIsOpen, isMobile }: HeaderProps) {
  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          background: '#E95BBB',
          boxShadow: 'none',
          padding: { xs: '10px 20px', sm: '25px 20px 23px 20px' },
          height: { xs: '48px', sm: '88px' },
        }}
      >
        <Toolbar
          sx={{
            display: 'flex',
            justifyContent: 'center',
            padding: '0px !important',
            height: '100%',
            minHeight: '0px !important',
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              maxWidth: { sm: '1200px' },
            }}
          >
            <Box sx={{ width: { xs: '94px', sm: '113px' }, height: { xs: '15px', sm: '26px' } }}>
              <WhiteLogo />
            </Box>

            <Button
              variant="outlined"
              sx={{
                padding: { xs: '7.5px 11px', sm: '12px 18px 11px 18px' },
                backgroundColor: 'white',
                color: '#D955AE',
                borderRadius: '30px',
                fontWeight: 800,
                border: 'none',
                fontSize: { xs: '11px', sm: '15px' },
                letterSpacing: { xs: '0' },
                lineHeight: { xs: '100%' },
                width: { xs: '78px', sm: '117px' },
                height: { xs: '28px', sm: '40px' },
                fontFamily: 'NanumSquare Neo',
              }}
              onClick={() => {
                if (isMobile) {
                  window.open('https://lobster-mumble.onelink.me/64Km/ew5fiob4');
                } else {
                  setIsOpen(true);
                }
              }}
            >
              앱 다운로드
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar sx={{ height: '48px', minHeight: '0px !important' }} />
    </>
  );
}
